export default {"src":"/_next/static/media/diary.17404412.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};